/*
  Widerrufsfunktion (sections/wdr-form.liquid), zweistufig.
  Stufe 1 -> Übersicht -> „Widerruf bestätigen“ sendet über das Shopify-Kontaktformular.
  Keine Speicherung im Browser (kein localStorage, kein sessionStorage, keine Cookies),
  keine Anfragen an Dritte. Der Absendezeitpunkt reist im Formular (contact[submitted_at]) mit
  und wird vor dem Absenden als wdr_ts in die Adresse der Seite geschrieben (history.replaceState).
  Shopify leitet nach dem Absenden auf diese Adresse zurück; die Bestätigung liest wdr_ts aus der URL.
*/
(function () {
  'use strict';

  var RM = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var LANG = document.documentElement.lang || undefined;
  var TS_MIN = Date.UTC(2020, 0, 1);

  function fmtDate(d) {
    try { return new Intl.DateTimeFormat(LANG, { day: 'numeric', month: 'long', year: 'numeric' }).format(d); }
    catch (e) { return d.toISOString().slice(0, 10); }
  }
  function fmtTime(d) {
    try { return new Intl.DateTimeFormat(LANG, { hour: '2-digit', minute: '2-digit', second: '2-digit', timeZoneName: 'short' }).format(d); }
    catch (e) { return d.toTimeString().slice(0, 8); }
  }
  function isoLocal(d) {
    var p = function (n) { return (n < 10 ? '0' : '') + n; };
    var off = -d.getTimezoneOffset();
    var sign = off >= 0 ? '+' : '-';
    off = Math.abs(off);
    return d.getFullYear() + '-' + p(d.getMonth() + 1) + '-' + p(d.getDate()) + 'T' + p(d.getHours()) + ':' +
      p(d.getMinutes()) + ':' + p(d.getSeconds()) + sign + p(Math.floor(off / 60)) + ':' + p(off % 60);
  }

  /* Bestätigung nach dem Absenden: Zeitpunkt des Klicks auf „Widerruf bestätigen“ aus der URL
     (wdr_ts). Fehlt er (z. B. weil Shopify beim Rücksprung die Adresse gekürzt hat), gilt der
     Ladezeitpunkt dieser Bestätigungsseite, also Sekunden nach dem Absenden. */
  function initDone(root) {
    var done = root.querySelector('[data-wdr-done]');
    if (!done) return;
    var line = done.querySelector('[data-wdr-time]');
    var ts = NaN;
    try { ts = parseInt(new URLSearchParams(window.location.search).get('wdr_ts'), 10); } catch (e) {}
    if (!(isFinite(ts) && ts > TS_MIN && ts <= Date.now() + 60000)) ts = Date.now();
    if (line) {
      var d = new Date(ts);
      line.textContent = (line.getAttribute('data-tpl') || '').replace('__D__', fmtDate(d)).replace('__T__', fmtTime(d));
    }
    root.querySelectorAll('[data-wdr-stp]').forEach(function (li) {
      if (li.getAttribute('data-wdr-stp') === 'done') li.setAttribute('aria-current', 'step');
      else li.removeAttribute('aria-current');
    });
    try { done.focus({ preventScroll: false }); } catch (e) {}
  }

  function initForm(root, t) {
    var form = root.querySelector('form.wdr__form');
    if (!form) return;
    form.noValidate = true;
    var stEdit = form.querySelector('[data-wdr-stage="edit"]');
    var stReview = form.querySelector('[data-wdr-stage="review"]');
    if (!stEdit || !stReview) return;
    var btnNext = form.querySelector('[data-wdr-next]');
    var btnBack = form.querySelector('[data-wdr-back]');
    var btnConfirm = form.querySelector('[data-wdr-confirm]');
    var sum = form.querySelector('[data-wdr-sum]');
    var summary = form.querySelector('[data-wdr-summary]');
    var consentErr = form.querySelector('[data-wdr-consent-error]');
    var tsField = form.querySelector('[data-wdr-ts]');
    var steps = root.querySelectorAll('[data-wdr-stp]');
    var stage = 'edit';
    var sending = false;

    function setErr(el, msg) {
      var wrap = el.closest('.form-field');
      if (!wrap) return;
      var p = wrap.querySelector('.wdr-err');
      if (msg) {
        el.setAttribute('aria-invalid', 'true');
        if (!p) { p = document.createElement('p'); p.className = 'form-field__error wdr-err'; p.id = el.id + '-err'; wrap.appendChild(p); }
        p.textContent = msg;
        el.setAttribute('aria-describedby', p.id);
      } else {
        el.removeAttribute('aria-invalid');
        el.removeAttribute('aria-describedby');
        if (p) p.remove();
      }
    }
    function check(el) {
      var msg = '';
      var v = (el.value || '').trim();
      if (el.type === 'checkbox') {
        if (!el.hasAttribute('required')) return true;
        msg = el.checked ? '' : 'x';
        if (consentErr) consentErr.hidden = !msg;
        if (msg) el.setAttribute('aria-invalid', 'true'); else el.removeAttribute('aria-invalid');
        return !msg;
      }
      if (el.hasAttribute('required') && !v) msg = t.required;
      else if (v && el.type === 'email' && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)) msg = t.email;
      setErr(el, msg);
      return !msg;
    }
    function validate() {
      var bad = null;
      stEdit.querySelectorAll('input:not([type="hidden"]), textarea, select').forEach(function (el) {
        if (!check(el) && !bad) bad = el;
      });
      if (summary) summary.hidden = !bad;
      if (bad) {
        bad.focus();
        if (bad.scrollIntoView) bad.scrollIntoView({ block: 'center', behavior: RM ? 'auto' : 'smooth' });
      }
      return !bad;
    }
    function labelFor(el) {
      var l = form.querySelector('label[for="' + el.id + '"]');
      if (!l) return el.name;
      var c = l.cloneNode(true);
      c.querySelectorAll('[aria-hidden="true"]').forEach(function (n) { n.remove(); });
      return c.textContent.replace(/\s+/g, ' ').trim();
    }
    function buildSummary() {
      while (sum.firstChild) sum.removeChild(sum.firstChild);
      stEdit.querySelectorAll('input:not([type="hidden"]):not([type="checkbox"]), textarea, select').forEach(function (el) {
        var v = (el.value || '').trim();
        var dt = document.createElement('dt');
        var dd = document.createElement('dd');
        dt.textContent = labelFor(el);
        dd.textContent = v || t.empty;
        sum.appendChild(dt);
        sum.appendChild(dd);
      });
    }
    function setStage(s) {
      stage = s;
      stEdit.hidden = s !== 'edit';
      stReview.hidden = s !== 'review';
      btnConfirm.disabled = s !== 'review';
      steps.forEach(function (li) {
        if (li.getAttribute('data-wdr-stp') === s) li.setAttribute('aria-current', 'step');
        else li.removeAttribute('aria-current');
      });
      var h = (s === 'edit' ? stEdit : stReview).querySelector('[data-wdr-focus]');
      var top = form.closest('.wdr__panel') || form;
      if (top.getBoundingClientRect().top < 0 && top.scrollIntoView) top.scrollIntoView({ block: 'start', behavior: RM ? 'auto' : 'smooth' });
      if (h) { try { h.focus({ preventScroll: true }); } catch (e) { h.focus(); } }
    }
    function toReview() {
      if (!validate()) return;
      buildSummary();
      setStage('review');
    }

    btnNext.addEventListener('click', toReview);
    btnBack.addEventListener('click', function () { setStage('edit'); });

    form.addEventListener('submit', function (e) {
      if (sending) { e.preventDefault(); return; }
      if (stage !== 'review') {
        e.preventDefault();
        toReview();
        return;
      }
      if (!validate()) {
        e.preventDefault();
        setStage('edit');
        validate();
        return;
      }
      var now = new Date();
      tsField.value = isoLocal(now) + ' (' + fmtDate(now) + ' ' + fmtTime(now) + ')';
      /* Zeitpunkt in die aktuelle Adresse schreiben (nur die URL, keine Speicherung): Shopify leitet
         nach dem Absenden auf die aufrufende Seite zurück (Referer) und hängt contact_posted=true an;
         wdr_ts reist so mit und wird in der Bestätigung angezeigt. */
      try {
        var params = new URLSearchParams(window.location.search);
        params.delete('contact_posted');
        params.set('wdr_ts', String(now.getTime()));
        window.history.replaceState(window.history.state, '', window.location.pathname + '?' + params.toString());
        /* Rücksprungziel (return_to) mit Sprachpfad, wdr_ts und übrigen Parametern, plus contact_posted=true. */
        params.set('contact_posted', 'true');
        var rt = form.querySelector('input[name="return_to"]');
        if (rt) rt.value = window.location.pathname + '?' + params.toString() + (form.id ? '#' + form.id : '');
      } catch (err) {}
      sending = true;
      btnConfirm.disabled = true;
      btnConfirm.setAttribute('aria-busy', 'true');
    });

    form.addEventListener('input', function (e) {
      var el = e.target;
      if (el && el.getAttribute && el.getAttribute('aria-invalid') === 'true') check(el);
    });
    form.addEventListener('change', function (e) {
      var el = e.target;
      if (el && el.type === 'checkbox') check(el);
    });
  }

  function init() {
    document.querySelectorAll('[data-wdr]').forEach(function (root) {
      var t = { required: '', email: '', empty: '—' };
      var host = root.parentElement || document;
      var j = host.querySelector('[data-wdr-i18n]');
      if (j) { try { t = JSON.parse(j.textContent); } catch (e) {} }
      initDone(root);
      initForm(root, t);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
